import { H3, Image, PortableText } from '@ahmdigital/ui';
import React from 'react';

import { ContentWrapper, ImageWrapper, ItemWrapper, StyledButton } from './styles';

export type BenefitItemType = {
  cta?: {
    title: string;
    to: string;
  };
  description?: string | null;
  image?: {
    alt: string;
    src: string;
  } | null;
  isReverse?: boolean;
  title?: string | null;
};

const BenefitItem = ({ cta, description, image, isReverse, title }: BenefitItemType) => (
  <ItemWrapper isReverse={isReverse}>
    {image && (
      <ImageWrapper>
        <Image {...image} />
      </ImageWrapper>
    )}
    <ContentWrapper>
      {title && <H3 variant="marginBottomSpacer9">{title}</H3>}
      {description && <PortableText source={description} variant="marginBottomSpacer9" />}
      {cta?.to && (
        <StyledButton to={cta.to} variant={['border', 'white']}>
          {cta.title}
        </StyledButton>
      )}
    </ContentWrapper>
  </ItemWrapper>
);

export default BenefitItem;
